import React, { Component } from "react";

import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import CommonServices from "../../services/axiosServices/apiServices/CommonServices";
import IndividualMemberService from "../../services/axiosServices/apiServices/IndividualMemberService";
import SwalServices from "../../services/swalServices/SwalServices";

export default class MembershipUploadInterface extends Component {
  constructor(props) {

    super(props);
    this.CommonServices = new CommonServices()
    this.IndividualMemberService = new IndividualMemberService()
    this.swalServices = new SwalServices();
    this.state = {
      File1Details: {
        fileName: "",
        filePath: "",
        fullFilePath: ""
      },
      File2Details: {
        fileName: "",
        filePath: "",
        fullFilePath: ""
      },
      File3Details: {
        fileName: "",
        filePath: "",
        fullFilePath: ""
      },
      membershipReportFormDetail: {
        csisMembershipHistoryId: null,
        fileOnePath: null,
        fileTwoPath: null,
        fileThreePath: null,
        newRecordCount: null,
        associateMemberCount: null,
        fellowMemberCount: null,
        cgiStudentMemberCount: null,
        nonMemberCount: null,
        otherCount: null,
        totalCount: null,
        isConfirmed: null,
        isUploaded: null

      },
      validationRules: {
        // File1Details: [
        //   {
        //     type: "require",
        //     message: ErrorMessage.SelectRequired.replace(
        //       "{0}",
        //       "At least one file"
        //     ),
        //   },
        // ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.File1Details,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.File1Details,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };


  // This onFileChange is without Api calll

  // onFileChange = (event, fileKey) => {
  //   const file = event.target.files[0];
  //   const allowedTypes = [
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     "application/vnd.ms-excel",
  //   ];

  //   if (file && allowedTypes.includes(file.type)) {
  //     this.setState((prevState) => ({
  //       [fileKey]: {
  //         ...prevState[fileKey],
  //         fileName: file.name,
  //       },
  //     }), () => {
  //       this.swalServices.Success("File Selected Successfully");
  //     });
  //   } else {
  //     this.swalServices.Error("Please select a valid Excel file (.xls, .xlsx)");
  //   }
  // };




  onFileChange = (event, fileKey) => {
    const file = event.target.files[0];
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel" // .xls
    ];
    if (file && allowedTypes.includes(file.type)) {
      let request = {};
      request.storagePath = "MembershipUploadedExcels";
      request.file = file;
      request.fileName = file.name;

      this.CommonServices.UploadExcels(request).then((response) => {
        if (response != null) {
          if (request.storagePath === "MembershipUploadedExcels") {
            const updatedDetails = {
              fileName: file.name,
              filePath: response.fileName,
              fullFilePath: response.fullFilePath
            };

            this.setState({ [fileKey]: updatedDetails }, () => {
              this.swalServices.Success("File Uploaded Successfully");
            });
          }
        } else {
          this.swalServices.Error(response.message);
        }
      });
    } else {
      this.swalServices.Error("Please select a valid file");
    }
  };


  UpdateFiles = () => {
    let request = { ...this.state.membershipReportFormDetail }
    request.fileOnePath = this.state.File1Details.fullFilePath
    request.fileTwoPath = this.state.File2Details.fullFilePath
    request.fileThreePath = this.state.File3Details.fullFilePath

    let isValidInput = this.isAnyFileSelected();
    if (isValidInput) {

      this.IndividualMemberService.importMembershipRecordFromExcel(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let errorMessage = response.responseItem.responseContent.errorMessage;
          if(errorMessage!=='Email already Exists.'){
          let req = {};
          req.cSISMembershipHistoryId = response.responseItem.responseContent.keyId



          this.IndividualMemberService.addCSISMembersFromHistory(req).then((response) => {

          })



          this.swalServices.Success("Membership data has been updated.");
        }
        else{
          this.swalServices.Error("Excel contains Duplicate Emails");
        }
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
    else {
      this.swalServices.Error("Please Select atleast 1 file")
    }
  };

  isAnyFileSelected = () => {
    const { File1Details, File2Details, File3Details } = this.state;
    return (
      File1Details.fileName ||
      File2Details.fileName ||
      File3Details.fileName
    );
  };

  downloadFileFromUrl = (url) => {
    const fileName = url.split('/').pop()
    const aTag = document.createElement('a')
    aTag.href = url
    aTag.setAttribute('download', fileName)
    document.body.appendChild(aTag)
    aTag.click()
    aTag.remove()
  };
  render() {
    return (
      <div className="main-body-section">
        <div className="custom-card shadow-lg mb-10">
          <div className="flex items-center justify-between w-1/2 mb-5">
            <div className=" font-bold text-[#757575] text-[16px]  text-gray-800">
              Update Files
            </div>
            <div>
              <button className="font-bold text-blue-400 text-[16px]" onClick={() => { this.downloadFileFromUrl('/MembershipUploads_DownloadTemplate.xlsx') }}>
                Download Template
              </button>
            </div>
          </div>
          <div className="col-span-12 mb-5">
            <div className="flex items-center mb-3 gap-4">
              <label className="text-[#757575] text-[16px] mobile-14 whitespace-nowrap" >
                File 1
              </label>

              <div className="flex flex-1 items-center gap-4">
                <input
                  className="w-1/2 custom-input"
                  type="text"
                  value={this.state.File1Details.fileName}
                  disabled
                />
                <form className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-red-border">
                  <label
                    htmlFor="upload_File1"
                    className="text-uplod block text-sm font-bold text-[#C00000] whitespace-nowrap cursor-pointer"
                  >
                    Select File
                  </label>
                  <input
                    className="sr-only"
                    id="upload_File1"
                    type="file"
                    name="file1"
                    onChange={(event) => this.onFileChange(event, "File1Details")}
                    accept=".xls, .xlsx"
                  />
                </form>
              </div>
            </div>
          </div>
          <div>
          </div>
          <div className="col-span-12 mb-5">
            <div className="flex items-center mb-3 gap-4">
              <label className="text-[#757575] text-[16px] mobile-14 whitespace-nowrap">
                File 2
              </label>

              <div className="flex flex-1 items-center gap-4">
                <input
                  className="w-1/2 custom-input"
                  type="text"
                  name=""
                  value={this.state.File2Details.fileName}
                  disabled
                />
                <form className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-red-border">
                  <label
                    htmlFor="upload_File2"
                    className="text-uplod block text-sm font-bold text-[#C00000] whitespace-nowrap cursor-pointer"
                  >
                    Select File
                  </label>
                  <input
                    className="sr-only"
                    id="upload_File2"
                    type="file"
                    onChange={(event) => this.onFileChange(event, "File2Details")}
                    name="file2"
                    accept=".xls, .xlsx"
                  />
                </form>
              </div>
            </div>
          </div>
          <div className="col-span-12 mb-5">
            <div className="flex items-center mb-3 gap-4">
              <label className="text-[#757575] text-[16px] mobile-14 whitespace-nowrap">
                File 3
              </label>

              <div className="flex flex-1 items-center gap-4">
                <input
                  className="w-1/2 custom-input"
                  type="text"
                  value={this.state.File3Details.fileName}
                  disabled
                />
                <form className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-red-border">
                  <label
                    htmlFor="upload_File3"
                    className="text-uplod block text-sm font-bold text-[#C00000] whitespace-nowrap cursor-pointer"
                  >
                    Select File
                  </label>
                  <input
                    className="sr-only"
                    id="upload_File3"
                    type="file"
                    name="file3"
                    onChange={(event) => this.onFileChange(event, "File3Details")}
                    accept=".xls, .xlsx"
                  />
                </form>
              </div>
            </div>
          </div>

          <div className="col-span-12 flex justify-start">
            <button className={`w-32 px-7 py-2 btn-sm btn-red text-lg text-white `}
              onClick={() => {
                this.UpdateFiles();
              }}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    );
  }
}
